import type { SupWeb3Address } from "@/types";
import type { Strategies } from "@/../config/swr.config";

import useApi from "@/hooks/api/useApi";
import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";

export type SupProtocolRewardType = "token" | "points";

export type SupProtocolRewardSource = "vault" | "protocol" | "infra";

export interface SupProtocolRewardToken {
  id: string;
  address: SupWeb3Address;
  chain_id: 1;
  name: string;
  symbol: string;
  decimals: number;
  logo: string;
}

export interface SupProtocolRewardSimplified {
  amount: bigint;
  amount_usd: number;
  chain_id: number;
  reward_id: string;
  source_type: SupProtocolRewardSource;
  token: SupProtocolRewardToken;
}

export interface SupProtocolReward extends SupProtocolRewardSimplified {
  reward_type: SupProtocolRewardType;
  reward_name: string;
}

export interface ResponseProtocolRewards {
  total_amount_usd: number;
  rewards: SupProtocolReward[] | null;
}

/**
 * @package api:go
 * @link https://superform-xyz.postman.co/workspace/Superform~fe57d318-f198-4f97-9c50-0b2a5a78dbac/request/30355904-99097653-f4cd-437e-8c7f-e5b0769d3217?action=share&source=copy-link&creator=26633220&active-environment=9faa12dd-452a-4b02-81a7-eced0431d716
 * @param {Strategies} strategy
 */
export default function useProtocolRewards(strategy: Strategies = "on-mount") {
  const userAddress = useWeb3UserAddress();

  const { data, isLoading, isError, mutate } = useApi<ResponseProtocolRewards, ResponseProtocolRewards>(
    {
      path: `/protocolRewards/earning/${userAddress}/`,
      api: "v2",
    },
    {
      enabled: !!userAddress,
      strategy,
    }
  );

  return {
    data,
    isLoading,
    isError,
    mutate,
  };
}
